/* eslint-disable react/jsx-indent */
import React from 'react';
import MeetingCards from './meetingCards';
import UpcomingMCards from './upcomingMCards';
import StartJoining from './startJoinMeeting';

const ConferenceRoomBdy = (props) =>
{
	const { meetingsList, setSelectedMeeting, selectedMeeting, setMeet, handleInstant, userdetails } = props;

	return (
		<div className='flexRow fullH'>
			<div className='ConleftCntr flexAutoCol'>
				<MeetingCards setMeet={setMeet} handleInstant={handleInstant} />
				<div className='flexRow pdngHXS'>
					<span className='txt20px graytextcolor'>Next Upcoming meetings for Today</span>
				</div>
				<UpcomingMCards setSelectedMeeting={setSelectedMeeting} selectedMeeting={selectedMeeting} meetingsList={meetingsList} />
			</div>
			<div className='ConrightCntr flexAutoCol pdngHXS mrgnTXS'>
				<StartJoining selectedMeeting={selectedMeeting} userdetails={userdetails} />
			</div>
		</div>
	);
};

export default ConferenceRoomBdy;
